import { render, staticRenderFns } from "./EditSpecificQuality.vue?vue&type=template&id=35c4468b"
import script from "./EditSpecificQuality.vue?vue&type=script&lang=js"
export * from "./EditSpecificQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports